// Componente indicatore di progresso per sistema ExeDialog DDT2026
// Mostra i passi completati e permette di tornare indietro
import React from 'react';

// Mappa campo_da_verificare -> etichetta e ordine
// destinazione vs destinazione_pattern dipende da trasporto_carico_nostro
const BASE_STEP_MAP = [
    { campo: 'cod_bolla', label: 'Bolla', params: ['cod_bolla', 'num_bolla', 'data_bolla'] },
    { campo: 'rag_soc', label: 'Cliente', params: ['rag_soc'] },
    { campo: 'targa', label: 'Targa', params: ['targa'] },
    { campo: 'rag_soc_vettore', label: 'Vettore', params: ['rag_soc_vettore', 'vett_ns'] },
    { campo: 'rag_soc_conducente', label: 'Conducente', params: ['rag_soc_conducente'] },
    { campo: 'cod_commessa', label: 'Commessa', params: ['cod_commessa', 'data_inizio', 'cod_artic', 'descrizion'] },
    // Lo step destinazione viene sostituito dinamicamente
    { campo: 'destinazione', campoAlt: 'destinazione_pattern', label: 'Destinazione', params: ['destinazione', 'id_dest', 'destinazione_pattern'] },
    { campo: 'num_silos', label: 'Silos', params: ['num_silos'] },
    { campo: 'temperatura', label: 'Temperatura', params: ['temperatura'] },
    { campo: 'cig', label: 'CIG/CUP', params: ['cig', 'cup'] },
    { campo: 'stampante', label: 'Stampa', params: ['stampante', 'stamparescontrino'] },
    // dtara/dlordo (correzioni di peso) e cellulare esistono solo nel coupon
    { campo: 'tara', campoAlt2: 'lordo', label: 'Pesi', params: ['pesospec', 'tara', 'dtara', 'dlordo', 'lordo'] },
    { campo: 'conferma', label: 'Conferma', params: ['cellulare', 'conferma'] },
];

// Genera la mappa con il campo corretto per destinazione
function getStepMap(trasportoCaricoNostro) {
    return BASE_STEP_MAP.map(step => {
        if (step.campoAlt && trasportoCaricoNostro) {
            return { ...step, campo: step.campoAlt };
        }
        return step;
    });
}

export function StepIndicator({ currentStep, searchParams, onNavigate, verificaData }) {
    const trasportoCaricoNostro = verificaData?.valori_verificati?.trasporto_carico_nostro;
    const ddt = verificaData?.valori_accessori?.ddt || {};
    const STEP_MAP = getStepMap(trasportoCaricoNostro);
    
    // Step disabilitati (non attivabili per questo tipo bolla)
    const disabledSteps = new Set();
    if (!ddt.num_silos) disabledSteps.add('num_silos');
    if (!ddt.temperatura) disabledSteps.add('temperatura');

    // Trova l'indice dello step corrente (supporta campi alternativi come campoAlt, campoAlt2)
    const currentIndex = STEP_MAP.findIndex(s => 
        s.campo === currentStep || s.campoAlt === currentStep || 
        s.campoAlt2 === currentStep
    );

    const handleStepClick = (stepIndex) => {
        if (stepIndex >= currentIndex) return; // Non si può avanzare cliccando
        
        // Rimuovi tutti i parametri da questo step in poi
        const paramsToRemove = STEP_MAP.slice(stepIndex)
            .flatMap(s => s.params);
        
        const newParams = new URLSearchParams(searchParams);
        paramsToRemove.forEach(p => newParams.delete(p));
        
        onNavigate(newParams);
    };

    return (
        <div className="mt-4 mb-3">
            <div className="d-flex flex-wrap gap-1">
                {STEP_MAP.map((step, index) => {
                    const isCompleted = index < currentIndex;
                    const isCurrent = index === currentIndex;
                    const isDisabled = disabledSteps.has(step.campo);

                    let className = 'badge ';
                    if (isDisabled) {
                        className += 'bg-light text-muted border';
                    } else if (isCompleted) {
                        className += 'bg-success text-white';
                    } else if (isCurrent) {
                        className += 'bg-primary text-white';
                    } else {
                        className += 'bg-secondary text-white opacity-50';
                    }

                    return (
                        <span
                            key={step.campo}
                            className={className}
                            style={{ 
                                cursor: (isCompleted && !isDisabled) ? 'pointer' : 'default',
                                padding: '0.4em 0.6em',
                                fontSize: '0.85em',
                                ...(isDisabled ? { textDecoration: 'line-through', opacity: 0.5 } : {})
                            }}
                            onClick={() => isCompleted && !isDisabled && handleStepClick(index)}
                            title={isDisabled ? `${step.label} non previsto` : (isCompleted ? `Torna a ${step.label}` : (isCurrent ? 'Passo corrente' : ''))}
                        >
                            {index + 1}. {step.label}
                        </span>
                    );
                })}
            </div>
        </div>
    );
}
